import { defineComponent, createBlock, openBlock, unref, withCtx, createVNode, renderSlot, createTextVNode, toDisplayString } from "vue";
import _sfc_main$2 from "./Tooltip.js";
import _sfc_main$4 from "./TooltipContent.js";
import _sfc_main$1 from "./TooltipProvider.js";
import _sfc_main$3 from "./TooltipTrigger.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "TooltipWrapper",
  props: {
    content: {},
    placement: {}
  },
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createBlock(unref(_sfc_main$1), null, {
      default: withCtx(() => [
        createVNode(unref(_sfc_main$2), null, {
          default: withCtx(() => [
            createVNode(unref(_sfc_main$3), { "as-child": "" }, {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "default")
              ]),
              _: 3
            }),
            createVNode(unref(_sfc_main$4), { side: _ctx.placement }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(_ctx.content), 1)
              ]),
              _: 1
            }, 8, ["side"])
          ]),
          _: 3
        })
      ]),
      _: 3
    }));
  }
});
export {
  _sfc_main as default
};
